<ion-app>
  <ion-header>
    <ion-toolbar>
      <ion-title>
        <span class="brand-title">
          <span class="brand-icon" aria-hidden="true"></span>
          <span>Wahl Advertising</span>
        </span>
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-content>
  <ng-container *ngIf="!selectedLegalPage; else legalPageTemplate">
  <ion-grid>
    <ion-row class="user-row">
      <ion-col size="12">
        <section class="auth user-strip">
          <div class="actions compact">
            <ng-container *ngIf="!authToken">
              <ion-button
                type="button"
                size="small"
                fill="outline"
                *ngFor="let provider of oauthProviders"
                (click)="startOAuth(provider.id)"
              >
                {{ provider.label }}
              </ion-button>
            </ng-container>
            <ion-button type="button" size="small" fill="outline" *ngIf="authToken" (click)="openUserModal()">User</ion-button>
          </div>

          <div class="user-strip__details">
            <ion-note color="medium" *ngIf="currentEmail">{{ currentEmail }}</ion-note>
            <ion-note color="medium" *ngIf="authMessage">{{ authMessage }}</ion-note>
          </div>
        </section>
      </ion-col>
    </ion-row>

    <ion-row class="tester-notice-row" *ngIf="authToken">
      <ion-col size="12">
        <section class="tester-notice" aria-label="Request for app testers">
          <div>
            <strong>Request for testers</strong>
            <p>
              We are looking for signed-in users to test the Android app. Please join the
              <a [href]="supportLinks.googleGroup" target="_blank" rel="noopener noreferrer">noisy-user-app-testers@googlegroups.com</a>
              Google group, then install the app from Google Play.
            </p>
          </div>
          <div class="tester-notice__actions">
            <ion-button type="button" size="small" fill="outline" [href]="supportLinks.androidApp" target="_blank" rel="noopener noreferrer">
              Join on Android
            </ion-button>
            <ion-button type="button" size="small" fill="outline" [href]="supportLinks.googlePlayTest" target="_blank" rel="noopener noreferrer">
              Join on the web
            </ion-button>
          </div>
        </section>
      </ion-col>
    </ion-row>

    <ion-row class="tool-nav-row">
      <ion-col size="12">
        <ion-segment
          class="tool-segment"
          color="primary"
          [scrollable]="true"
          [selectOnFocus]="true"
          [value]="selectedTool"
          (ionChange)="onSelectedToolChange($event.detail.value)"
        >
          <ion-segment-button value="qr">
            <ion-label>QR</ion-label>
          </ion-segment-button>
          <ion-segment-button *ngIf="authToken" value="stickers">
            <ion-label>Stickers</ion-label>
          </ion-segment-button>
          <ion-segment-button value="businessCard">
            <ion-label>CARD</ion-label>
          </ion-segment-button>
          <ion-segment-button *ngIf="canShowNfcTool" value="nfc">
            <ion-label>NFC</ion-label>
          </ion-segment-button>
          <ion-segment-button *ngIf="marketingEmailEnabled" value="marketingEmail">
            <ion-label>Email</ion-label>
          </ion-segment-button>
        </ion-segment>
      </ion-col>
    </ion-row>

    <ion-row class="limit-row" *ngIf="usageLimitNoticeMessage()">
      <ion-col size="12">
        <section class="limit-notice">
          <strong>{{ usageLimitNoticeTitle() }}</strong>
          <p>{{ usageLimitNoticeMessage() }}</p>
          <a *ngIf="authToken" href="#" (click)="openBilling($event)">Subscribe for $10/month</a>
        </section>
      </ion-col>
    </ion-row>

    <ion-row class="workspace" role="main">
      <ion-col
        *ngIf="selectedTool !== 'marketingEmail'"
        size="12"
        [sizeLg]="selectedTool === 'nfc' || selectedTool === 'stickers' ? '12' : '5'"
        [sizeXl]="selectedTool === 'nfc' || selectedTool === 'stickers' ? '12' : '4'"
      >
        <section class="panel">
          <app-qr-code-form
            *ngIf="selectedTool === 'qr'"
            [form]="form"
            [qrStyles]="qrStyles"
            [errorMessage]="errorMessage"
            [generatedImageUrl]="generatedImageUrl"
            [isSaving]="isSaving"
            [categorySuggestions]="categorySuggestions()"
            [selectedCategoryNames]="selectedCategoryNames(form)"
            [userAgentPresets]="userAgentRoutePresets"
            [userAgentRouteSummaries]="userAgentRouteSummaries(form)"
            [canManageUserAgentRoutes]="!!authToken"
            [canSkipResponseValidation]="urlResponseValidationBypassAllowed"
            (generate)="createQrCode()"
            (logoSelected)="onLogoSelected($event)"
            (addCategory)="toggleCategoryInForm(form, $event)"
            (addUserAgentRoute)="addUserAgentRouteToForm(form)"
            (removeUserAgentRoute)="removeUserAgentRouteFromForm(form, $event)"
            (download)="downloadQrCode()"
          ></app-qr-code-form>

          <app-qr-import
            *ngIf="selectedTool === 'qr' && authToken"
            [message]="qrImportMessage"
            [errors]="qrImportErrors"
            (csvSelected)="importQrCodesFromCsv($event)"
            (downloadTemplate)="downloadQrImportTemplate()"
          ></app-qr-import>

          <app-sticker-printer
            *ngIf="selectedTool === 'stickers' && authToken"
            [stickerSize]="activeQrStickerSize"
            [layoutColumns]="stickerSheetLayout().columns"
            [layoutRows]="stickerSheetLayout().rows"
            [assignmentCount]="stickerSheetAssignmentCount()"
            [qrCodes]="qrCodes"
            [assignments]="stickerSheetAssignments"
            [assignedQrCodes]="stickerSheetQrCodes"
            [searchQuery]="qrCodeSearchQuery"
            [isLoading]="isLoadingQrCodes"
            [page]="qrCodePage"
            [totalPages]="qrCodeTotalPages"
            (stickerSizeChange)="updateStickerSize($event)"
            (assignmentChange)="updateStickerSheetAssignment($event)"
            (searchChange)="onQrCodeSearchChange($event)"
            (pageChange)="loadQrCodePage($event)"
            (print)="printQrStickerSheet()"
          ></app-sticker-printer>

          <form *ngIf="selectedTool === 'businessCard'" [formGroup]="businessCardForm" (ngSubmit)="saveBusinessCard()" class="form">
            <ion-grid class="business-card-editor-grid">
              <ion-row>
                <ion-col size="12">
                  <div class="history-header">
                    <h2>{{ selectedBusinessCardSide === 'front' ? 'Front' : 'Back' }} Text</h2>
                    <span class="section-actions">
                      <ion-button type="button" size="small" fill="outline" (click)="addBusinessCardTextSection()">Add Text</ion-button>
                      <label class="upload-button">
                        <span>Add Logo</span>
                        <input type="file" accept="image/*" multiple aria-label="Add business card logos" (change)="addBusinessCardLogoSections($event)">
                      </label>
                    </span>
                  </div>
                </ion-col>
              </ion-row>

              <ion-row>
                <ion-col size="12">
                  <ion-list lines="full" class="business-card-editor-list">
                    <ion-item class="business-card-editor-item" *ngFor="let section of businessCardTextSectionsForSelectedSide(); trackBy: trackBusinessCardTextSection">
                      <div class="rich-text-field">
                        <input
                          [id]="businessCardTrixInputId(section.id)"
                          type="hidden"
                          [value]="businessCardTextSectionHtml(section)"
                        >
                        <trix-editor
                          class="business-card-rich-editor"
                          [attr.input]="businessCardTrixInputId(section.id)"
                          aria-label="Business card text"
                          placeholder="Enter text for this section"
                          (trix-initialize)="syncBusinessCardTextEditor(section.id, true, $any($event.target))"
                          (trix-change)="updateBusinessCardTextSectionHtml(section.id, $any($event.target).value)"
                          (trix-file-accept)="$event.preventDefault()"
                        ></trix-editor>
                      </div>
                      <ion-button
                        slot="end"
                        type="button"
                        fill="clear"
                        color="danger"
                        aria-label="Remove text section"
                        (click)="removeBusinessCardTextSection(section.id)"
                      >
                        Remove
                      </ion-button>
                    </ion-item>
                  </ion-list>
                </ion-col>
              </ion-row>

              <ion-row>
                <ion-col size="12">
                  <ion-list lines="full" class="business-card-editor-list">
                    <ion-item>
                      <ion-toggle
                        [checked]="businessCardSnapToGrid"
                        (ionChange)="businessCardSnapToGrid = $event.detail.checked"
                      >
                        Snap to grid
                      </ion-toggle>
                      <ion-button type="button" fill="outline" slot="end" (click)="snapBusinessCardTextSectionsToGrid()">
                        Snap Text
                      </ion-button>
                    </ion-item>

                    <ion-item>
                      <ion-label position="stacked">Grid Spacing</ion-label>
                      <ion-range
                        min="1"
                        max="10"
                        step="1"
                        [snaps]="true"
                        [value]="businessCardGridSize"
                        (ionChange)="updateBusinessCardGridSize($any($event.detail.value))"
                      ></ion-range>
                    </ion-item>

                    <ion-item>
                      <ion-label position="stacked">Background Color</ion-label>
                      <ion-input
                        type="color"
                        [value]="businessCardBackgroundForSelectedSide().color"
                        (ionInput)="updateBusinessCardBackgroundColor($any($event.detail.value))"
                      ></ion-input>
                    </ion-item>

                    <ion-item>
                      <ion-label>Use other side background</ion-label>
                      <ion-button type="button" fill="outline" slot="end" (click)="matchBusinessCardBackgroundFromOtherSide()">
                        {{ selectedBusinessCardSide === 'front' ? 'Match Back' : 'Match Front' }}
                      </ion-button>
                    </ion-item>

                    <ion-item>
                      <ion-label position="stacked">Background Style</ion-label>
                      <ion-select
                        interface="popover"
                        [value]="businessCardBackgroundForSelectedSide().style"
                        (ionChange)="updateBusinessCardBackgroundStyle($any($event.detail.value))"
                      >
                        <ion-select-option *ngFor="let style of businessCardBackgroundStyles" [value]="style.id">
                          {{ style.label }}
                        </ion-select-option>
                      </ion-select>
                    </ion-item>

                    <ion-item>
                      <ion-label position="stacked">Style Strength</ion-label>
                      <ion-range
                        min="0"
                        max="100"
                        [value]="businessCardBackgroundForSelectedSide().fade"
                        (ionChange)="updateBusinessCardBackgroundFade($any($event.detail.value))"
                      ></ion-range>
                    </ion-item>

                    <ion-item>
                      <ion-label position="stacked">Background Picture</ion-label>
                      <input class="file-input" type="file" accept="image/*" aria-label="Business card background picture" (change)="onBusinessCardBackgroundImageSelected($event)">
                      <ion-button
                        slot="end"
                        type="button"
                        fill="clear"
                        color="danger"
                        *ngIf="businessCardBackgroundForSelectedSide().imageDataUrl"
                        (click)="removeBusinessCardBackgroundImage()"
                      >
                        Remove
                      </ion-button>
                    </ion-item>

                    <ion-item>
                      <ion-label position="stacked">Categories</ion-label>
                      <ion-input formControlName="categoryNames" placeholder="Spring, handouts, trade show"></ion-input>
                    </ion-item>
                  </ion-list>
                </ion-col>
              </ion-row>

              <ion-row *ngIf="categorySuggestions().length > 0">
                <ion-col size="12">
                  <div class="category-picker">
                    <button type="button" class="category-chip" [class.active]="categorySelected(businessCardForm, categoryName)" *ngFor="let categoryName of categorySuggestions()" (click)="toggleCategoryInForm(businessCardForm, categoryName)">
                      {{ categoryName }}
                    </button>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>

            <ion-grid class="qr-options" *ngIf="businessCardQrCodesForSelectedSide().length > 0 || authToken">
              <ion-row>
                <ion-col size="12">
                  <div class="history-header">
                    <h2>Attached QR Codes</h2>
                  </div>
                </ion-col>
              </ion-row>

              <ion-row *ngIf="businessCardQrCodesForSelectedSide().length > 0">
                <ion-col size="12">
                  <div class="qr-chip-list">
                    <span class="qr-chip" *ngFor="let qrCode of businessCardQrCodesForSelectedSide()">
                      {{ qrCode.title || qrCode.target_url }}
                      <button type="button" (click)="removeBusinessCardQrCode(qrCode)">Remove</button>
                    </span>
                  </div>
                </ion-col>
              </ion-row>

              <ion-row *ngIf="businessCardQrCodesForSelectedSide().length > 0">
                <ion-col size="12">
                  <ion-list lines="full">
                    <ion-item *ngFor="let qrCode of businessCardQrCodesForSelectedSide()">
                      <ion-label position="stacked">{{ qrCode.title || qrCode.target_url }} Size</ion-label>
                      <ion-range
                        min="8"
                        max="42"
                        step="1"
                        [value]="businessCardQrCodeSize(qrCode)"
                        (ionChange)="updateBusinessCardQrCodeSize(qrCode, $any($event.detail.value))"
                      ></ion-range>
                    </ion-item>
                  </ion-list>
                </ion-col>
              </ion-row>

              <ion-row *ngIf="authToken">
                <ion-col size="12">
                  <app-saved-qr-code-picker
                    searchInputId="business-card-qr-search"
                    label="Existing QR Code"
                    emptyMessage="No saved QR codes match this search."
                    [qrCodes]="qrCodes"
                    [selectedQrCodeId]="selectedExistingBusinessCardQrCodeId"
                    [searchQuery]="qrCodeSearchQuery"
                    [isLoading]="isLoadingQrCodes"
                    [page]="qrCodePage"
                    [totalPages]="qrCodeTotalPages"
                    (selectQrCode)="addExistingQrCodeToBusinessCardFromPicker($event)"
                    (searchChange)="onQrCodeSearchChange($event)"
                    (pageChange)="loadQrCodePage($event)"
                  ></app-saved-qr-code-picker>
                </ion-col>
              </ion-row>
            </ion-grid>

            <ion-note color="medium" *ngIf="businessCardMessage">{{ businessCardMessage }}</ion-note>

            <div class="actions">
              <ion-button type="submit" [disabled]="isSavingBusinessCard">
                <ion-spinner *ngIf="isSavingBusinessCard" name="crescent"></ion-spinner>
                <span *ngIf="!isSavingBusinessCard">{{ authToken ? 'Save Card' : 'Preview Card' }}</span>
              </ion-button>
              <ion-button type="button" fill="outline" [disabled]="isSavingBusinessCard" (click)="newBusinessCard()">
                New Card
              </ion-button>
              <ion-button type="button" fill="outline" [disabled]="isSavingBusinessCard" (click)="printBusinessCardSheet()">
                Print Business Card
              </ion-button>
            </div>
          </form>

          <form *ngIf="selectedTool === 'nfc'" [formGroup]="businessCardForm" (ngSubmit)="writeBusinessCardNfcTag()" class="form">
            <div class="nfc-options">
              <div class="history-header">
                <h2>NFC Tag</h2>
              </div>

              <ion-list lines="full">
                <ion-item>
                  <ion-label position="stacked">Tag Name</ion-label>
                  <ion-input [formControl]="nfcTagForm.controls.title" placeholder="Front counter contact tag"></ion-input>
                </ion-item>

                <ion-item>
                  <ion-label position="stacked">NFC Payload</ion-label>
                  <ion-select [(ngModel)]="businessCardNfcPayloadMode" [ngModelOptions]="{ standalone: true }" interface="popover">
                    <ion-select-option value="url">Website or QR URL</ion-select-option>
                    <ion-select-option value="vcard">vCard from fields</ion-select-option>
                  </ion-select>
                </ion-item>

                <ion-item
                  class="nfc-lock-item"
                  button
                  detail="false"
                  [disabled]="!canLockBusinessCardNfc || isWritingBusinessCardNfc || isMassWritingBusinessCardNfc"
                  (click)="toggleBusinessCardNfcLockAfterWrite($event)"
                >
                  <ion-label>
                    <h3>Lock tag after write</h3>
                    <p *ngIf="!canLockBusinessCardNfc">Available in the installed Android app.</p>
                  </ion-label>
                  <ion-toggle
                    slot="end"
                    [(ngModel)]="lockBusinessCardNfcAfterWrite"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="!canLockBusinessCardNfc || isWritingBusinessCardNfc || isMassWritingBusinessCardNfc"
                    aria-label="Lock tag after write"
                  ></ion-toggle>
                </ion-item>
              </ion-list>

              <ion-list lines="full" *ngIf="businessCardNfcPayloadMode === 'vcard'">
                <ion-item>
                  <ion-label position="stacked">Full Name</ion-label>
                  <ion-input formControlName="name" placeholder="Jane Smith"></ion-input>
                </ion-item>

                <ion-item>
                  <ion-label position="stacked">Job Title</ion-label>
                  <ion-input formControlName="jobTitle" placeholder="Owner"></ion-input>
                </ion-item>

                <ion-item>
                  <ion-label position="stacked">Company</ion-label>
                  <ion-input formControlName="company" placeholder="Wahl Advertising"></ion-input>
                </ion-item>

                <ion-item>
                  <ion-label position="stacked">Phone</ion-label>
                  <ion-input type="tel" formControlName="phone" placeholder="(555) 123-4567"></ion-input>
                </ion-item>

                <ion-item>
                  <ion-label position="stacked">Email</ion-label>
                  <ion-input type="email" formControlName="email" placeholder="jane@example.com"></ion-input>
                </ion-item>

                <ion-item>
                  <ion-label position="stacked">Website</ion-label>
                  <ion-input type="url" formControlName="website" placeholder="https://example.com"></ion-input>
                </ion-item>

                <ion-item>
                  <ion-label position="stacked">Address</ion-label>
                  <ion-textarea formControlName="address" autoGrow="true" rows="2" placeholder="123 Main St, Springfield, IL"></ion-textarea>
                </ion-item>

                <ion-item>
                  <ion-label position="stacked">Note</ion-label>
                  <ion-textarea formControlName="tagline" autoGrow="true" rows="2" placeholder="Appointments available weekdays"></ion-textarea>
                </ion-item>
              </ion-list>

              <section class="nfc-qr-selection" *ngIf="businessCardNfcPayloadMode === 'url' && authToken">
                <div class="nfc-qr-selection__selected" *ngIf="selectedNfcQrCode">
                  <div>
                    <span>{{ selectedNfcQrCode.title || selectedNfcQrCode.redirect_path }}</span>
                    <small>{{ nfcQrCodeDisplayUrl(selectedNfcQrCode) }}</small>
                  </div>
                  <div class="nfc-qr-selection__actions">
                    <ion-button type="button" size="small" fill="outline" (click)="openNfcQrCodeSearch()">
                      Change
                    </ion-button>
                    <ion-button type="button" size="small" fill="clear" (click)="clearNfcQrCodeSelection()">
                      Clear
                    </ion-button>
                  </div>
                </div>

                <app-saved-qr-code-picker
                  *ngIf="isNfcQrCodeSearchVisible()"
                  searchInputId="nfc-qr-search"
                  label="Search QR Codes"
                  emptyMessage="No saved QR codes match this search."
                  [qrCodes]="qrCodes"
                  [selectedQrCodeId]="selectedExistingNfcQrCodeId"
                  [searchQuery]="qrCodeSearchQuery"
                  [isLoading]="isLoadingQrCodes"
                  [page]="qrCodePage"
                  [totalPages]="qrCodeTotalPages"
                  (selectQrCode)="selectExistingNfcQrCode($event)"
                  (searchChange)="onQrCodeSearchChange($event)"
                  (pageChange)="loadQrCodePage($event)"
                ></app-saved-qr-code-picker>
              </section>

              <ion-list lines="full" *ngIf="businessCardNfcPayloadMode === 'url'">
                <ion-item>
                  <ion-label position="stacked">Website / URL</ion-label>
                  <ion-input type="url" formControlName="website" placeholder="Select a QR code, or enter a URL"></ion-input>
                </ion-item>
              </ion-list>

              <div class="nfc-target">
                <span>{{ businessCardNfcTargetLabel() }}</span>
              </div>

              <ion-note color="medium" *ngIf="businessCardNfcMessage">{{ businessCardNfcMessage }}</ion-note>
              <ion-note color="medium" *ngIf="nfcTagMessage">{{ nfcTagMessage }}</ion-note>

              <div class="actions">
                <ion-button
                  type="submit"
                  fill="outline"
                  [disabled]="isSavingBusinessCard || isCheckingBusinessCardNfc || isWritingBusinessCardNfc || isMassWritingBusinessCardNfc || !canWriteBusinessCardNfc"
                >
                  <ion-spinner *ngIf="isCheckingBusinessCardNfc || isWritingBusinessCardNfc" name="crescent"></ion-spinner>
                  <span *ngIf="!isCheckingBusinessCardNfc && !isWritingBusinessCardNfc">Write NFC Tag</span>
                </ion-button>
                <ion-button
                  type="button"
                  fill="clear"
                  *ngIf="isWritingBusinessCardNfc"
                  (click)="stopWriteBusinessCardNfcTag()"
                >
                  Cancel Write
                </ion-button>
                <ion-button
                  type="button"
                  fill="outline"
                  [disabled]="isSavingBusinessCard || isCheckingBusinessCardNfc || isWritingBusinessCardNfc || isMassWritingBusinessCardNfc || isBroadcastingBusinessCardNfc || !canWriteBusinessCardNfc"
                  (click)="massWriteBusinessCardNfcTags()"
                >
                  <ion-spinner *ngIf="isMassWritingBusinessCardNfc" name="crescent"></ion-spinner>
                  <span *ngIf="!isMassWritingBusinessCardNfc">Mass Write</span>
                  <span *ngIf="isMassWritingBusinessCardNfc">Mass Writing ({{ massWrittenBusinessCardNfcCount }})</span>
                </ion-button>
                <ion-button
                  type="button"
                  fill="clear"
                  *ngIf="isMassWritingBusinessCardNfc"
                  (click)="stopMassWriteBusinessCardNfcTags()"
                >
                  Stop Mass Write
                </ion-button>
                <ion-button
                  type="button"
                  fill="outline"
                  [disabled]="isSavingBusinessCard || isCheckingBusinessCardNfc || isWritingBusinessCardNfc || isMassWritingBusinessCardNfc || isBroadcastingBusinessCardNfc || !canBroadcastBusinessCardNfc"
                  (click)="sendBusinessCardNfcTag()"
                >
                  <ion-spinner *ngIf="isBroadcastingBusinessCardNfc" name="crescent"></ion-spinner>
                  <span *ngIf="!isBroadcastingBusinessCardNfc">Send Tag</span>
                </ion-button>
                <ion-button
                  type="button"
                  fill="clear"
                  *ngIf="isBroadcastingBusinessCardNfc"
                  [disabled]="isStoppingBusinessCardNfcBroadcast"
                  (click)="stopBusinessCardNfcBroadcast()"
                >
                  <ion-spinner *ngIf="isStoppingBusinessCardNfcBroadcast" name="crescent"></ion-spinner>
                  <span *ngIf="!isStoppingBusinessCardNfcBroadcast">Stop Broadcast</span>
                </ion-button>
                <ion-button type="button" [disabled]="isSavingNfcTag" (click)="saveNfcTag()">
                  <ion-spinner *ngIf="isSavingNfcTag" name="crescent"></ion-spinner>
                  <span *ngIf="!isSavingNfcTag">{{ selectedNfcTag ? 'Update Tag' : 'Save Tag' }}</span>
                </ion-button>
                <ion-button type="button" fill="outline" [disabled]="isSavingNfcTag" (click)="newNfcTag()">
                  New Tag
                </ion-button>
              </div>

              <section class="history" *ngIf="authToken">
                <div class="history-header">
                  <h2>Your NFC Tags</h2>
                </div>

                <ion-note color="medium" *ngIf="isLoadingNfcTags">Loading NFC tags...</ion-note>
                <ion-note color="medium" *ngIf="!isLoadingNfcTags && nfcTags.length === 0">No saved NFC tags yet.</ion-note>

                <div class="qr-list" *ngIf="nfcTags.length > 0">
                  <div
                    class="qr-list-item"
                    *ngFor="let nfcTag of nfcTags"
                    [class.active]="selectedNfcTag?.id === nfcTag.id"
                  >
                    <button type="button" class="qr-list-main" (click)="selectNfcTag(nfcTag)">
                      <span class="qr-title">{{ nfcTag.title }}</span>
                      <span class="qr-target">{{ nfcTag.payload_mode === 'vcard' ? (nfcTag.contact.name || 'vCard contact') : nfcTag.target_url }}</span>
                      <span class="qr-meta">{{ nfcTag.payload_mode === 'vcard' ? 'vCard' : 'URL' }}</span>
                    </button>
                    <span class="qr-actions">
                      <button
                        type="button"
                        class="qr-inline-action danger"
                        [disabled]="deletingNfcTagId === nfcTag.id"
                        (click)="deleteNfcTag(nfcTag)"
                      >
                        {{ deletingNfcTagId === nfcTag.id ? 'Deleting...' : 'Delete' }}
                      </button>
                    </span>
                  </div>
                </div>
              </section>
            </div>
          </form>

          <app-qr-history
            [visible]="selectedTool === 'qr' && !!authToken"
            [qrCodes]="qrCodes"
            [selectedQrCodeId]="generatedRecord?.id || null"
            [editingId]="editingId"
            [deletingId]="deletingId"
            [isLoading]="isLoadingQrCodes"
            [searchQuery]="qrCodeSearchQuery"
            [page]="qrCodePage"
            [totalPages]="qrCodeTotalPages"
            [totalCount]="qrCodeTotalCount"
            (selectQrCode)="selectQrCode($event)"
            (editQrCode)="startEditingQrCode($event)"
            (deleteQrCode)="deleteQrCode($event)"
            (searchChange)="onQrCodeSearchChange($event)"
            (pageChange)="loadQrCodePage($event)"
          ></app-qr-history>

          <app-business-card-history
            [visible]="selectedTool === 'businessCard' && !!authToken"
            [businessCards]="businessCards"
            [selectedBusinessCardId]="generatedBusinessCard?.id || null"
            [deletingBusinessCardId]="deletingBusinessCardId"
            [isLoading]="isLoadingBusinessCards"
            (selectBusinessCard)="selectBusinessCard($event)"
            (deleteBusinessCard)="deleteBusinessCard($event)"
          ></app-business-card-history>
        </section>
      </ion-col>

      <ion-col
        *ngIf="selectedTool !== 'nfc' && selectedTool !== 'stickers'"
        [class.preview-column]="selectedTool !== 'marketingEmail'"
        size="12"
        [sizeLg]="selectedTool === 'marketingEmail' ? '12' : '7'"
        [sizeXl]="selectedTool === 'marketingEmail' ? '12' : '8'"
      >
        <app-qr-preview
          [visible]="selectedTool === 'qr'"
          [generatedRecord]="generatedRecord"
          [directQrUrl]="directQrUrl"
          [generatedImageUrl]="generatedImageUrl"
        ></app-qr-preview>

        <app-business-card-preview
          [visible]="selectedTool === 'businessCard'"
          [selectedSide]="selectedBusinessCardSide"
          [textSections]="businessCardTextSectionsForSelectedSide()"
          [logoSections]="businessCardLogoSectionsForSelectedSide()"
          [qrCodes]="businessCardQrCodesForSelectedSide()"
          [qrImages]="businessCardQrImages"
          [backgroundStyle]="businessCardBackgroundStyle()"
          [showGrid]="businessCardSnapToGrid"
          [gridStyle]="businessCardGridStyle()"
          [elementStyle]="businessCardElementStyle.bind(this)"
          [qrElementId]="qrElementId.bind(this)"
          (selectedSideChange)="selectBusinessCardSide($event)"
          (editText)="focusBusinessCardTextSection($event)"
          (dragStart)="startBusinessCardDragFromPreview($event)"
          (dragMove)="moveBusinessCardElement($event)"
          (dragStop)="stopBusinessCardDrag($event)"
          (removeLogo)="removeBusinessCardLogoSection($event)"
        ></app-business-card-preview>

        <app-marketing-email
          [visible]="selectedTool === 'marketingEmail'"
          [authToken]="authToken"
        ></app-marketing-email>

      </ion-col>
    </ion-row>
  </ion-grid>

  <div #businessCardPrintSheet class="business-card-print-source" aria-hidden="true">
    <section class="business-card-print-page" aria-label="Business card front print sheet">
      <app-business-card-renderer
        *ngFor="let _copy of businessCardPrintCopies"
        [textSections]="businessCardTextSectionsForSide('front')"
        [logoSections]="businessCardLogoSectionsForSide('front')"
        [qrCodes]="businessCardQrCodesForSide('front')"
        [qrImages]="businessCardQrImages"
        [backgroundStyle]="businessCardBackgroundStyle('front')"
        [elementStyle]="businessCardPrintElementStyle.bind(this, 'front')"
        [qrElementId]="qrElementId.bind(this)"
      ></app-business-card-renderer>
    </section>

    <section class="business-card-print-page" aria-label="Business card back print sheet">
      <app-business-card-renderer
        *ngFor="let _copy of businessCardPrintCopies"
        [textSections]="businessCardTextSectionsForSide('back')"
        [logoSections]="businessCardLogoSectionsForSide('back')"
        [qrCodes]="businessCardQrCodesForSide('back')"
        [qrImages]="businessCardQrImages"
        [backgroundStyle]="businessCardBackgroundStyle('back')"
        [elementStyle]="businessCardPrintElementStyle.bind(this, 'back')"
        [qrElementId]="qrElementId.bind(this)"
      ></app-business-card-renderer>
    </section>
  </div>
  </ng-container>

  <ng-template #legalPageTemplate>
    <app-legal-page [page]="selectedLegalPage" (closePage)="closeLegalPage()"></app-legal-page>
  </ng-template>
  </ion-content>

  <ion-modal
    *ngIf="!selectedLegalPage"
    class="edit-modal"
    [isOpen]="isEditModalOpen"
    [breakpoints]="modalBreakpoints"
    [initialBreakpoint]="1"
    [handle]="false"
    [expandToScroll]="false"
    (didDismiss)="handleEditModalDismiss()"
  >
    <ion-header>
      <ion-toolbar>
        <ion-title>Edit QR Code</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content class="edit-modal-content">
      <form [formGroup]="editForm" (ngSubmit)="updateQrCode()" class="form edit-modal-form" *ngIf="editingRecord">
          <ion-note color="medium">
            {{ editingRecord.redirect_path }} keeps its route and scan history.
          </ion-note>

          <ion-list lines="full">
            <ion-item>
              <ion-label position="stacked">Title</ion-label>
              <ion-input formControlName="title" placeholder="Campaign or location"></ion-input>
            </ion-item>

            <ion-item>
              <ion-label position="stacked">QR Destination</ion-label>
              <ion-input formControlName="targetUrl" placeholder="https://example.com or myapp://offer/123"></ion-input>
            </ion-item>

            <ion-item *ngIf="urlResponseValidationBypassAllowed">
              <label class="checkbox-row">
                <input type="checkbox" formControlName="skipResponseValidation">
                <span>Skip website response check</span>
              </label>
              <ion-note color="medium">Keeps URL format checks, but skips DNS and HTTP reachability checks.</ion-note>
            </ion-item>

            <ion-item *ngIf="authToken">
              <ion-label position="stacked">User Agent Routes</ion-label>
              <ion-select formControlName="userAgentPreset" interface="popover" placeholder="Choose a route type">
                <ion-select-option *ngFor="let preset of userAgentRoutePresets" [value]="preset.id">
                  {{ preset.label }}
                </ion-select-option>
              </ion-select>
            </ion-item>

            <ion-item *ngIf="authToken">
              <ion-label position="stacked">Route Destination</ion-label>
              <ion-input formControlName="userAgentTargetUrl" placeholder="myapp://offer or https://example.com/mobile"></ion-input>
            </ion-item>

            <ion-item *ngIf="authToken">
              <ion-label position="stacked">Redirect Percentage</ion-label>
              <ion-input
                type="number"
                inputmode="numeric"
                formControlName="userAgentRedirectPercentage"
                min="1"
                max="100"
                step="1"
                placeholder="100"
                (ionInput)="syncUserAgentFrequencyChoice(editForm, 'percentage')"
              ></ion-input>
            </ion-item>

            <ion-item *ngIf="authToken">
              <ion-label position="stacked">Every Nth Scan</ion-label>
              <ion-input
                type="number"
                inputmode="numeric"
                formControlName="userAgentEveryNthScan"
                min="1"
                max="10000"
                step="1"
                placeholder="Optional"
                (ionInput)="syncUserAgentFrequencyChoice(editForm, 'nth')"
              ></ion-input>
            </ion-item>

            <ion-item *ngIf="authToken">
              <ion-button type="button" fill="outline" (click)="addUserAgentRouteToForm(editForm)">Add User Agent Route</ion-button>
            </ion-item>

            <ion-item>
              <ion-label position="stacked">Icon Area Size</ion-label>
              <ion-input type="number" inputmode="numeric" formControlName="qrIconSize" min="12" max="32" step="1"></ion-input>
            </ion-item>

            <ion-item>
              <ion-label position="stacked">Logo</ion-label>
              <input #editLogoInput class="file-input" type="file" accept="image/*" aria-label="QR code logo" (change)="onEditLogoSelected($event)">
              <ion-button
                slot="end"
                type="button"
                fill="clear"
                color="danger"
                *ngIf="editLogoDataUrl"
                (click)="removeEditQrLogo()"
              >
                Remove
              </ion-button>
            </ion-item>

            <ion-item>
              <ion-label position="stacked">Style</ion-label>
              <ion-select formControlName="qrStyle" interface="popover">
                <ion-select-option *ngFor="let style of qrStyles" [value]="style.id">
                  {{ style.label }}
                </ion-select-option>
              </ion-select>
            </ion-item>

            <ion-item>
              <ion-label position="stacked">Categories</ion-label>
              <ion-input formControlName="categoryNames" placeholder="Spring, web, storefront"></ion-input>
            </ion-item>

            <ion-item>
              <label class="checkbox-row disabled">
                <input type="checkbox" formControlName="trackAnalytics">
                <span>Use tracked redirect analytics</span>
              </label>
            </ion-item>

            <ion-item *ngIf="editForm.controls['trackAnalytics'].value">
              <label class="checkbox-row">
                <input type="checkbox" formControlName="providedByPage">
                <span>Show a provided-by page before redirecting</span>
              </label>
              <ion-note color="medium">Adds a brief Wahl Advertising page before redirecting. This helps support the site owner.</ion-note>
            </ion-item>
          </ion-list>

          <div class="category-picker" *ngIf="categorySuggestions().length > 0">
            <button type="button" class="category-chip" [class.active]="categorySelected(editForm, categoryName)" *ngFor="let categoryName of categorySuggestions()" (click)="toggleCategoryInForm(editForm, categoryName)">
              {{ categoryName }}
            </button>
          </div>

          <div class="route-list" *ngIf="authToken && userAgentRouteSummaries(editForm).length > 0">
            <span class="route-chip" *ngFor="let route of userAgentRouteSummaries(editForm); let routeIndex = index">
              <span class="route-chip-label">{{ route }}</span>
              <button type="button" (click)="removeUserAgentRouteFromForm(editForm, routeIndex)">Remove</button>
            </span>
          </div>

          <ion-note color="danger" *ngIf="errorMessage">{{ errorMessage }}</ion-note>

          <div class="actions modal-actions">
            <ion-button type="submit" [disabled]="isSaving">
              <ion-spinner *ngIf="isSaving" name="crescent"></ion-spinner>
              <span *ngIf="!isSaving">Save Changes</span>
            </ion-button>
            <ion-button type="button" fill="clear" [disabled]="isSaving" (click)="cancelEdit()">
              Cancel
            </ion-button>
          </div>
      </form>
    </ion-content>
  </ion-modal>

  <ion-modal
    *ngIf="!selectedLegalPage"
    [isOpen]="isUserModalOpen"
    (didDismiss)="closeUserModal()"
  >
    <ion-header>
      <ion-toolbar>
        <ion-title>User</ion-title>
        <ion-button slot="end" fill="clear" type="button" (click)="closeUserModal()">Close</ion-button>
      </ion-toolbar>
    </ion-header>

    <ion-content>
        <ion-list lines="full">
          <ion-item>
            <ion-label>
              <h2>{{ currentEmail }}</h2>
            </ion-label>
            <ion-button slot="end" type="button" fill="outline" color="danger" (click)="logout()">Log Out</ion-button>
          </ion-item>

          <ion-item>
            <ion-label>
              <h3>Account Context</h3>
              <p>{{ currentAccountLabel }}</p>
            </ion-label>
            <ion-select
              slot="end"
              interface="popover"
              [ngModel]="selectedCompanyContext"
              [disabled]="isLoadingAccountContext || isSavingAccountContext"
              [ngModelOptions]="{ standalone: true }"
              (ionChange)="switchCompanyContext($any($event.detail.value))"
              aria-label="Account context"
            >
              <ion-select-option value="individual">Individual</ion-select-option>
              <ion-select-option *ngFor="let company of companies; trackBy: trackCompanyContext" [value]="company.id">{{ company.name }}</ion-select-option>
            </ion-select>
          </ion-item>

          <ion-item>
            <ion-label position="stacked">New Company</ion-label>
            <ion-input [(ngModel)]="newCompanyName" [ngModelOptions]="{ standalone: true }" placeholder="Organization name"></ion-input>
            <ion-button slot="end" type="button" fill="outline" [disabled]="isCreatingCompany || !newCompanyName.trim()" (click)="createCompany()">
              <ion-spinner *ngIf="isCreatingCompany"></ion-spinner>
              <span *ngIf="!isCreatingCompany">Create</span>
            </ion-button>
          </ion-item>

          <ion-item *ngIf="canInviteCompanyMembers">
            <ion-label position="stacked">Invite Member</ion-label>
            <ion-input type="email" [(ngModel)]="inviteEmail" [ngModelOptions]="{ standalone: true }" placeholder="person@example.com"></ion-input>
            <ion-select [(ngModel)]="inviteRole" [ngModelOptions]="{ standalone: true }" interface="popover" aria-label="Invite role">
              <ion-select-option value="member">Member</ion-select-option>
              <ion-select-option value="admin">Admin</ion-select-option>
              <ion-select-option value="owner">Owner</ion-select-option>
            </ion-select>
            <ion-button slot="end" type="button" fill="outline" [disabled]="isInvitingCompanyMember || !inviteEmail.trim()" (click)="inviteCompanyMember()">
              <ion-spinner *ngIf="isInvitingCompanyMember"></ion-spinner>
              <span *ngIf="!isInvitingCompanyMember">Invite</span>
            </ion-button>
          </ion-item>

          <ion-item *ngFor="let invitation of pendingCompanyInvitations; trackBy: trackCompanyInvitation">
            <ion-label>
              <h3>{{ invitation.company.name }}</h3>
              <p>Invited by {{ invitation.invited_by_email }} as {{ invitation.role }}</p>
            </ion-label>
            <ion-button slot="end" type="button" fill="outline" (click)="acceptCompanyInvitation(invitation.token)">Accept</ion-button>
          </ion-item>

          <ion-item *ngIf="accountContextMessage">
            <ion-note color="medium">{{ accountContextMessage }}</ion-note>
          </ion-item>
        </ion-list>

        <ion-list lines="full">
          <ion-item>
            <ion-label>
              <h3>Do Not Track My Scans</h3>
              <p>QR scans made while signed in are saved without IP address, user agent, or referrer.</p>
            </ion-label>
            <ion-toggle
              slot="end"
              [ngModel]="currentUserDoNotTrack"
              [ngModelOptions]="{ standalone: true }"
              (ionChange)="updateCurrentUserDoNotTrack($any($event.detail.checked))"
              aria-label="Do not track my scans"
            ></ion-toggle>
          </ion-item>

          <ion-item>
            <ion-label>
              <h3>Skip Provided-By Page</h3>
              <p>New tracked QR codes will redirect directly without the Wahl Advertising pause page.</p>
            </ion-label>
            <ion-toggle
              slot="end"
              [ngModel]="currentUserSkipProvidedByPage"
              [ngModelOptions]="{ standalone: true }"
              (ionChange)="updateCurrentUserSkipProvidedByPage($any($event.detail.checked))"
              aria-label="Skip provided-by page"
            ></ion-toggle>
          </ion-item>
        </ion-list>

        <ion-list lines="full" [formGroup]="apiTokenForm" *ngIf="isUserModalDetailsVisible">
          <ion-item>
            <ion-label>
              <h2>API Tokens</h2>
            </ion-label>
            <ion-button slot="end" type="button" fill="clear" [href]="swaggerUrl" target="_blank" rel="noopener noreferrer">Swagger</ion-button>
            <ion-button slot="end" type="button" fill="outline" [disabled]="isCreatingApiToken" (click)="createApiToken()">
              <ion-spinner *ngIf="isCreatingApiToken"></ion-spinner>
              <span *ngIf="!isCreatingApiToken">Create</span>
            </ion-button>
          </ion-item>

          <ion-item>
            <ion-label position="stacked">Expiration</ion-label>
            <ion-input type="datetime-local" formControlName="expiresAt"></ion-input>
          </ion-item>

          <ion-item>
            <ion-checkbox formControlName="neverExpires">Never expires</ion-checkbox>
          </ion-item>

          <ion-item *ngIf="apiTokenValue">
            <ion-label>
              <code>{{ apiTokenValue }}</code>
            </ion-label>
            <ion-button slot="end" type="button" fill="clear" (click)="copyApiToken()">Copy</ion-button>
          </ion-item>

          <ion-item *ngIf="apiTokenMessage">
            <ion-note color="medium">{{ apiTokenMessage }}</ion-note>
          </ion-item>

          <ion-item *ngFor="let apiToken of apiTokens; trackBy: trackApiToken">
            <ion-label>
              {{ apiTokenDateLabels[apiToken.id] }}
            </ion-label>
            <ion-button
              slot="end"
              type="button"
              fill="clear"
              color="danger"
              [disabled]="deletingApiTokenId === apiToken.id"
              (click)="deleteApiToken(apiToken)"
            >
              <ion-spinner *ngIf="deletingApiTokenId === apiToken.id"></ion-spinner>
              <span *ngIf="deletingApiTokenId !== apiToken.id">Revoke</span>
            </ion-button>
          </ion-item>

          <ion-item *ngIf="!isLoadingApiTokens && apiTokens.length === 0">
            <ion-note color="medium">No API tokens.</ion-note>
          </ion-item>
        </ion-list>

        <ion-list lines="full" *ngIf="isUserModalDetailsVisible">
          <ion-item>
            <ion-label>
              <h2>MCP API Setup</h2>
              <p>Use this endpoint to connect this QR codes and online marketing app from any MCP client that supports remote OAuth servers.</p>
            </ion-label>
            <ion-button slot="end" type="button" fill="outline" (click)="copyMarketingMcpServerUrl()">Copy URL</ion-button>
          </ion-item>

          <ion-item>
            <ion-label>
              <h3>Server URL</h3>
              <p>{{ marketingMcpServerUrl }}</p>
            </ion-label>
          </ion-item>

          <ion-item>
            <ion-label>
              <h3>1. Open Your MCP Client Settings</h3>
              <p>In ChatGPT, OpenAI tools, Claude, or another compatible MCP client, open the Apps, Connectors, Integrations, or MCP server settings.</p>
            </ion-label>
          </ion-item>

          <ion-item>
            <ion-label>
              <h3>2. Add a Remote MCP Server</h3>
              <p>Create a new custom or remote MCP server. Name it QR codes and online marketing, paste the server URL above, and choose OAuth authentication when the client asks for an auth method.</p>
            </ion-label>
          </ion-item>

          <ion-item>
            <ion-label>
              <h3>3. Authorize Access</h3>
              <p>Confirm the custom server, continue through the OAuth sign-in flow, and allow the client to connect to your Wahl Advertising account.</p>
            </ion-label>
          </ion-item>

          <ion-item>
            <ion-label>
              <h3>4. Use the Marketing Tools</h3>
              <p>After installation, ask your MCP client to create or manage QR-code marketing contacts and campaigns with this app.</p>
            </ion-label>
          </ion-item>
        </ion-list>

        <ion-list lines="full" *ngIf="!isUserModalDetailsVisible">
          <ion-item>
            <ion-note color="medium">Loading account tools...</ion-note>
          </ion-item>
        </ion-list>
    </ion-content>

    <ion-footer>
      <ion-toolbar>
        <ion-button slot="end" fill="clear" type="button" (click)="closeUserModal()">Close</ion-button>
      </ion-toolbar>
    </ion-footer>
  </ion-modal>

  <ion-footer class="legal-footer-shell">
    <ion-toolbar>
      <app-legal-footer
        [supportLinks]="supportLinks"
        [legalLinks]="legalLinks"
        [legalExpanded]="legalExpanded"
        [canSubscribe]="!!authToken"
        (openCookiePreferences)="openCookiePreferences()"
        (openBilling)="openBilling($event)"
        (toggleLegal)="toggleLegal()"
        (openLegalPage)="openLegalPage($event.link, $event.event)"
      ></app-legal-footer>
    </ion-toolbar>
  </ion-footer>
</ion-app>
